<template>
  <div class="tw-min-h-[calc(100vh-60px)] tw-bg-gradient-to-br tw-from-slate-50 tw-via-white tw-to-indigo-50 tw-py-6">
    <div class="tw-mx-auto tw-w-full tw-max-w-6xl tw-px-4 sm:tw-px-6 lg:tw-px-8">
      <div class="tw-mb-5 tw-text-left">
        <h2 class="tw-text-2xl tw-font-semibold tw-text-slate-900">Settings</h2>
        <div class="tw-mt-1 tw-text-sm tw-text-slate-600">Manage terminals, drivers, trucks, and factoring preferences.</div>
      </div>

      <div class="tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-200/50">
        <div class="tw-px-4 tw-py-4 sm:tw-px-6">
          <div class="tw-flex tw-flex-wrap tw-gap-2">
            <button
              type="button"
              class="tw-rounded-full tw-border tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-transition"
              :class="activeTab === 'account'
                ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                : 'tw-border-slate-200/70 tw-bg-white/70 tw-text-slate-700 hover:tw-bg-white'"
              @click="activeTab = 'account'"
            >
              Account
            </button>

            <button
              type="button"
              class="tw-rounded-full tw-border tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-transition"
              :class="activeTab === 'terminal'
                ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                : 'tw-border-slate-200/70 tw-bg-white/70 tw-text-slate-700 hover:tw-bg-white'"
              @click="activeTab = 'terminal'"
            >
              Terminal Logins
            </button>

            <button
              type="button"
              class="tw-rounded-full tw-border tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-transition"
              :class="activeTab === 'drivers'
                ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                : 'tw-border-slate-200/70 tw-bg-white/70 tw-text-slate-700 hover:tw-bg-white'"
              @click="activeTab = 'drivers'"
            >
              Drivers
            </button>

            <button
              type="button"
              class="tw-rounded-full tw-border tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-transition"
              :class="activeTab === 'trucks'
                ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                : 'tw-border-slate-200/70 tw-bg-white/70 tw-text-slate-700 hover:tw-bg-white'"
              @click="activeTab = 'trucks'"
            >
              Trucks
            </button>

            <button
              type="button"
              class="tw-rounded-full tw-border tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-transition"
              :class="activeTab === 'vessels'
                ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                : 'tw-border-slate-200/70 tw-bg-white/70 tw-text-slate-700 hover:tw-bg-white'"
              @click="activeTab = 'vessels'"
            >
              Vessels
            </button>

            <button type="button"
              class="tw-rounded-full tw-border tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-transition" :class="activeTab === 'tracking'
                ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                : 'tw-border-slate-200/70 tw-bg-white/70 tw-text-slate-700 hover:tw-bg-white'" @click="activeTab = 'tracking'">
              Tracking
            </button>

            <button
              type="button"
              class="tw-rounded-full tw-border tw-border-slate-200/70 tw-bg-white/70 tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-slate-500 tw-opacity-60 tw-cursor-not-allowed"
              disabled
            >
              Factoring Company
            </button>
          </div>
        </div>

        <div class="tw-border-t tw-border-slate-200/70">
          <div v-show="activeTab === 'account'">
            <ProfileAccountTab />
          </div>
          <div v-show="activeTab === 'terminal'">
            <TerminalLogins />
          </div>
          <div v-show="activeTab === 'drivers'">
            <ProfileDriversTab />
          </div>
          <div v-show="activeTab === 'trucks'">
            <ProfileTrucksTab />
          </div>
          <div v-show="activeTab === 'vessels'">
            <ProfileVesselsTab />
          </div>
          <div v-show="activeTab === 'tracking'">
            <TrackingSettingsTab />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import ProfileQuery from '@/gql/company/profile.gql';
import ProfileMutation from '@/gql/company/mutations/UpdateCompanyInfo.gql';

import ProfileAccountTab from './ProfileAccountTab.vue';
import ProfileDriversTab from './ProfileDriversTab.vue';
import ProfileTrucksTab from './ProfileTrucksTab.vue';
import TrackingSettingsTab from './TrackingSettingsTab.vue'
import ProfileVesselsTab from './ProfileVesselsTab.vue';

import TerminalLogins from './TerminalLogins.vue';
import FactoringCompany from './FactoringCompany.vue';

export default defineComponent({
  components: {
    ProfileAccountTab,
    TerminalLogins,
    FactoringCompany,
    ProfileDriversTab,
    ProfileTrucksTab,
    ProfileVesselsTab,
    TrackingSettingsTab,
  },
  data() {
    return {
      loading: false,
      activeTab: 'terminal' as 'account' | 'terminal' | 'drivers' | 'trucks' | 'vessels' | 'tracking',
    };
  },
  methods: {},
  ...{
    apollo: {},
  },
});
</script>